import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const publicUsefulLinksUrl = `${SERVER_API}/public/useful-links`;

export const PUBLIC_USEFUL_LINKS_API = {
  LIST: {
    method: 'GET',
    url: publicUsefulLinksUrl,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${publicUsefulLinksUrl}/${id}`,
    };
  },
};
